import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Login from './views/Login.vue'
import Map from './views/Map.vue'
import CheckoutPoint from './views/CheckoutPoint.vue'
import OrderDetail from './views/OrderDetail.vue';
import NftOrderDetail from './views/NftOrderDetail.vue';
import RecipeDetail from './views/RecipeDetail.vue';
import CheckoutComplete from './views/CheckoutComplete.vue'
import AddressSearch from './views/AddressSearch.vue'
import Notice from './views/Notice.vue'
import Payment from './views/Payment.vue'
import Result from './views/Result.vue'
import RecipeIntroduce from './views/RecipeIntroduce.vue'
import RecipeIntroduceMain from './views/RecipeIntroduceMain.vue'
import NewCheckout from './views/NewCheckout.vue';
import PostDetail from './views/PostDetail.vue';
import Youtube from './views/Youtube.vue';
import RecMenuResult from './views/RecMenuResult.vue';
import RecMenu from './views/RecMenu.vue';
import Qrcode from './views/Qrcode.vue';
import CallbackDosi from './views/CallbackDosi.vue';
import ShahbetAttendance from '@/views/ShahbetAttendance.vue';

let router = [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/map',
      component: Map
    },
    {
      path: '/youtube',
      component: Youtube
    },
    {
      path: '/new/checkout',
      component: NewCheckout
    },
    {
      path: '/checkout/complete',
      component: CheckoutComplete
    },
    {
      path: '/callback/dosi',
      component: CallbackDosi
    },
    {
      path: '/checkoutPoint',
      component: CheckoutPoint
    },
    {
      path: '/orderDetail',
      component: OrderDetail
    },
    {
      path: '/nftOrderDetail',
      component: NftOrderDetail
    },
    {
      path: '/recipeDetail',
      component: RecipeDetail
    },
    {
      path: '/address/search',
      component: AddressSearch
    },
    {
      path: '/postDetail',
      component: PostDetail
    },
    {
      path: '/result',
      component: Result
    },
    {
      path: '/notice',
      component: Notice
    },
    {
      path: '/payment',
      component: Payment
    },
    {
      path: '/recipe',
      component: RecipeIntroduce
    },
    {
      path: '/recipe/main',
      component: RecipeIntroduceMain
    },
    { path: '/recmenu',
      component: RecMenu
    },
    { path: '/screen/search',
      component: RecMenuResult
    },
    { path: '/qrcode',
      component: Qrcode
    },
    {  path: '/attendance',
      name: 'ShahbetAttendance',
      component: ShahbetAttendance,
    },
    {
      path: '/',
      component: RecipeIntroduceMain
    },
    { path: '/*',
      component: NotFound
    }
];

export default router
